import Button from '@/components/atoms/Button'
import Icon from '@/components/atoms/Icon'
import Input from '@/components/atoms/Input'
import InputGroup from '@/components/atoms/InputGroup'
import Modal from '@/components/atoms/Modal'
import { whatsappSchema } from '@/schemas/whatsapp.schema'
import profileService from '@/services/profileService'
import { modalCreators } from '@/store/ducks/modal'
import { notificationCreators } from '@/store/ducks/notification'
import { useAppDispatch } from '@/store/hooks'
import inputIsValid from '@/utils/helpers/inputIsValid'
import { Dialog } from '@headlessui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

interface WhatsappProps {
	disabledOnClose?: boolean
}

type Inputs = {
	telephone: string
}

export function Whatsapp({ disabledOnClose }: WhatsappProps) {
	const dispatch = useAppDispatch()

	const {
		register,
		handleSubmit,
		setValue,
		formState: { errors, touchedFields },
	} = useForm<Inputs>({
		mode: 'onBlur',
		resolver: yupResolver(whatsappSchema),
	})

	const {
		execute: editProfile,
		isLoading,
		isSuccess,
	} = profileService.editMutation()

	const onSubmit = (data: Inputs) => {
		editProfile(data)
	}

	useEffect(() => {
		if (isSuccess) {
			dispatch(modalCreators.closeModal())
			dispatch(
				notificationCreators.show({
					message: 'Contato adicionado!',
				})
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess])

	return (
		<Modal
			name='whatsappModal'
			disabledOnClose={disabledOnClose}
			className='relative overflow-clip !px-0 !pt-10 !pb-0 max-w-[531px] border-[3px] rounded-2xl border-brand-primary'
		>
			<div className='absolute top-0 right-0'>
				<img
					src={`/imgs/admin/modals/whatsapp-top-right.png`}
					width='243px'
					height='auto'
					alt='Imagem de spray no modal whatsapp'
				/>
			</div>
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className='flex flex-col gap-10'>
					<div className='flex flex-col gap-5 px-6 md:px-12'>
						<Icon name='bell' width='88' height='88' />
						<div className='flex flex-col gap-8'>
							<div className='flex flex-col gap-4'>
								<Dialog.Title
									as='h3'
									className='text-start max-w-[335px] text-3xl font-bold leading-[110%] tracking-tight text-zinc-50'
								>
									Receba os lembretes por{' '}
									<span className='text-[#61eece]'>WhatsApp</span>
								</Dialog.Title>
								<p className='text-start w-full text-base text-zinc-50 leading-[140%]'>
									Adicione seu telefone para receber lembretes das aulas e
									outros eventos. Enviaremos apenas lembretes algumas horas
									antes.
								</p>
							</div>
							<InputGroup
								className='text-start'
								label='Contato'
								id='completeName'
							>
								<Input
									isValid={inputIsValid(
										errors.telephone,
										touchedFields.telephone
									)}
									{...register('telephone')}
									type='tel'
									format='(##) #####-####'
									placeholder='(11) 99999-9999'
									onValueChange={(values) => {
										setValue('telephone', values.value)
									}}
									className='mb-0 dark:bg-[#241D3A]'
								/>
							</InputGroup>
						</div>
					</div>
					<div className='w-full flex flex-col justify-end items-end px-6 py-5 bg-zinc-900'>
						<Button
							type='submit'
							className='w-full max-w-[210px] rounded-full h-[40px]'
							isLoading={isLoading}
							disabled={Object.keys(errors).length !== 0}
						>
							Adicionar contato
						</Button>
					</div>
				</div>
			</form>
		</Modal>
	)
}
